(function () {
  'use strict';

  if (window.__cpCartRecoveryLoaded) return;
  window.__cpCartRecoveryLoaded = true;

  var root = document.querySelector('[data-cart-recovery]');
  if (!root) return;

  var dialog = root.querySelector('.cart-recovery__dialog');
  var itemsWrap = root.querySelector('[data-cart-recovery-items]');

  var CONFIG = {
    checkoutUrl: root.getAttribute('data-checkout-url') || '/checkout',
    oncePerSession: root.getAttribute('data-once-per-session') === 'true',
    storageKey: root.getAttribute('data-storage-key') || 'cartRecoveryShown',
    dismissCooldown: parseInt(root.getAttribute('data-dismiss-cooldown'), 10) || 3600000,
    abVariant: root.getAttribute('data-ab-variant') || '',
    refreshOnTrigger: root.getAttribute('data-refresh-on-trigger') === 'true',
    moneyFormat: root.getAttribute('data-money-format') || '${{amount}}',
    bodyLockClass: root.getAttribute('data-body-lock-class') || 'crp-no-scroll'
  };
  var DISMISS_KEY = CONFIG.storageKey + '_dismissedUntil';

  /* ---------- storage helpers ---------- */ 

  function alreadyShownThisSession() {
    if (!CONFIG.oncePerSession) return false;
    try { return sessionStorage.getItem(CONFIG.storageKey) === '1'; }
    catch (e) { return false; }
  }
  function markShown() {
    try { sessionStorage.setItem(CONFIG.storageKey, '1'); } catch (e) {}
  }
  function dismissedRecently() {
    try {
      var until = parseInt(localStorage.getItem(DISMISS_KEY) || '0', 10);
      if (!until) return false;
      if (Date.now() < until) return true;
      localStorage.removeItem(DISMISS_KEY);
      return false;
    } catch (e) { return false; }
  }
  function markDismissed() {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now() + CONFIG.dismissCooldown)); }
    catch (e) {}
  }

  /* ---------- money formatting ---------- */

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = CONFIG.moneyFormat;
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? (decimal + parts[1]) : '';
      return whole + frac;
    }

    var match = fmt.match(placeholder);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' '); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- open / close ---------- */

  var isOpen = false;

  function openPopup() {
    if (isOpen) return;
    isOpen = true;
    markShown();
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('cart-recovery--open');
    document.body.classList.add('cart-recovery-locked');
    document.addEventListener('keydown', onKeyDown);
  }

  function closePopup(suppressForSession) {
    if (!isOpen) return;
    isOpen = false;
    if (suppressForSession === true) markDismissed();
    root.classList.remove('cart-recovery--open');
    document.body.classList.remove('cart-recovery-locked');
    document.removeEventListener('keydown', onKeyDown);
    setTimeout(function () { root.hidden = true; }, 260);
  }

  function onKeyDown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) closePopup(false);
  }

  /* ---------- theme cart drawer sync ---------- */

  function refreshThemeCart(drawer, data, sections) {
    if (!drawer) return;
    try {
      if (data.sections && typeof drawer._applySectionUpdates === 'function') {
        drawer._applySectionUpdates(data.sections);
        if (typeof drawer._bindDynamicListeners === 'function') drawer._bindDynamicListeners();
      } else if (typeof drawer._refresh === 'function') {
        drawer._refresh();
      }
      if (typeof drawer._updateCartCount === 'function') {
        var count = data.item_count != null ? data.item_count : (data.items ? data.items.length : 0);
        drawer._updateCartCount(count);
      }
    } catch (e) {}
  }

  function updateSubtotal(totalCents) {
    var money = formatMoney(totalCents);
    root.querySelectorAll('[data-cart-recovery-buy]').forEach(function (btn) {
      var base = btn.getAttribute('data-base-label') || 'BUY NOW';
      btn.textContent = base + ' - ' + money;
    });
  }

  /* ---------- remove item ---------- */

  function removeRow(itemEl) {
    if (!itemEl) return;
    itemEl.style.transition = 'opacity .25s ease, max-height .3s ease';
    itemEl.style.overflow = 'hidden';
    itemEl.style.maxHeight = itemEl.offsetHeight + 'px';
    itemEl.style.opacity = '0';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        itemEl.style.maxHeight = '0';
        itemEl.style.padding = '0';
        itemEl.style.margin = '0';
      });
    });
    setTimeout(function () {
      itemEl.remove();
      if (!root.querySelector('[data-cart-recovery-item]')) closePopup(false);
    }, 320);
  }

  function removeItem(key, itemEl, btn) {
    if (!key) { removeRow(itemEl); return; }
    if (btn) { btn.disabled = true; btn.style.opacity = '0.4'; }

    var drawer = document.querySelector('cart-drawer');
    var sections = (drawer && typeof drawer.getSectionsToRender === 'function')
      ? drawer.getSectionsToRender().map(function (s) { return s.section; })
      : ['cart-drawer', 'cart-bubble'];

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: key,
        quantity: 0,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        refreshThemeCart(drawer, data, sections);
        updateSubtotal(data.total_price || 0);
        removeRow(itemEl);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
      })
      .catch(function (err) {
        console.error('[cart-recovery] remove failed:', err);
        if (btn) { btn.disabled = false; btn.style.opacity = ''; }
      });
  }

  /* ---------- cart data + compare-at enrichment ---------- */

  function enrichWithCompareAtPrice(cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve(cart);

    var uniqueHandles = cart.items
      .map(function (it) { return it.handle; })
      .filter(function (h, i, arr) { return h && arr.indexOf(h) === i; });

    return Promise.all(
      uniqueHandles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var variantMap = {};
      products.forEach(function (p) {
        if (!p || !p.variants) return;
        p.variants.forEach(function (v) { variantMap[v.id] = v.compare_at_price; });
      });
      cart.items.forEach(function (it) {
        it.compare_at_price = variantMap[it.variant_id] || null;
      });
      return cart;
    });
  }

  function refreshFromCartJs() {
    if (!CONFIG.refreshOnTrigger) return Promise.resolve(true);
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(enrichWithCompareAtPrice)
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return false;
        rebuildItems(cart);
        updateSubtotal(cart.total_price || 0);
        return true;
      })
      .catch(function () { return true; });
  }

  /* ---------- render ---------- */

  function rebuildItems(cart) {
    if (!itemsWrap) return;
    var single = cart.items.length < 2;
    if (dialog) dialog.classList.toggle('cart-recovery__dialog--single', single);

    itemsWrap.innerHTML = cart.items.map(function (it) {
      var img = it.image
        ? '<img src="' + esc(it.image) + '&width=240" width="60" height="74" alt="' + esc(it.product_title || it.title) + '" loading="eager" decoding="async">'
        : '<span class="cart-recovery__item-media--empty"></span>';
      var coll = it.product_type
        ? '<p class="cart-recovery__item-collection">Collection: ' + esc(it.product_type) + '</p>' : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title')
        ? '<p class="cart-recovery__item-variant">' + esc(it.variant_title) + '</p>' : '';
      var inlineBtn = single
        ? '<a href="' + esc(CONFIG.checkoutUrl) + '" class="cart-recovery__checkout cart-recovery__checkout--inline" data-cart-recovery-buy data-base-label="BUY NOW">BUY NOW - ' + esc(formatMoney(cart.total_price)) + '</a>'
        : '';
      var comparePrice = (it.compare_at_price && it.compare_at_price > it.price)
        ? ' <s class="cart-recovery__item-compare-price">' + esc(formatMoney(it.compare_at_price * it.quantity)) + '</s>'
        : '';

      return ''
        + '<div class="cart-recovery__item" data-cart-recovery-item data-line-key="' + esc(it.key) + '">'
        + '<a class="cart-recovery__item-media" href="' + esc(it.url) + '">' + img + '</a>'
        + '<div class="cart-recovery__item-details">'
        + '<a class="cart-recovery__item-title" href="' + esc(it.url) + '">' + esc(it.product_title || it.title) + '</a>'
        + coll
        + '<p class="cart-recovery__item-price">' + esc(formatMoney(it.final_line_price || it.price || 0)) + comparePrice + '</p>'
        + variant
        + '<p class="cart-recovery__item-quantity">Qty: ' + esc(it.quantity) + '</p>'
        + '<button class="cart-recovery__remove" type="button" aria-label="Remove item from cart">'
        + '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>'
        + '<span class="cart-recovery__remove-label"></span>'
        + '</button>'
        + inlineBtn
        + '</div>'
        + '</div>';
    }).join('');
  }

  /* ---------- clicks (close / remove) ---------- */

  root.addEventListener('click', function (e) {
    if (e.target === root) { closePopup(false); return; }

    if (e.target.closest('.cart-recovery__close')) {
      closePopup(true);
      return;
    }

    var removeBtn = e.target.closest('.cart-recovery__remove');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var itemEl = removeBtn.closest('[data-cart-recovery-item]');
      removeItem(itemEl ? itemEl.getAttribute('data-line-key') : '', itemEl, removeBtn);
    }
  });

  /* ---------- exit-intent / visibility triggers ---------- */

  var hasFired = false;

  function attemptShow() {
    if (hasFired || isOpen) return;
    if (dismissedRecently()) return;
    if (alreadyShownThisSession()) return;
    if (!root.querySelector('[data-cart-recovery-item]') && !CONFIG.refreshOnTrigger) return;

    hasFired = true;
    refreshFromCartJs().then(function (hasItems) {
      if (hasItems === false || !root.querySelector('[data-cart-recovery-item]')) {
        hasFired = false;
        return;
      }
      openPopup();
    });
  }

  // Reliable exit-intent: fires once, exactly when the cursor leaves the document.
  document.addEventListener('mouseleave', function () {
    attemptShow();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') attemptShow();
  });

  window.addEventListener('pagehide', attemptShow);

  /* ---------- external trigger: body scroll-lock class ---------- */
  // Whenever <body> gains CONFIG.bodyLockClass (default "crp-no-scroll"),
  // force the popup open immediately — used when another script/drawer
  // wants to hand control of the locked-scroll state to this popup.

  function syncWithBodyScrollLock() {
    if (document.body.classList.contains(CONFIG.bodyLockClass)) {
      openPopup();
    }
  }

  var bodyClassObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === 'class') {
        syncWithBodyScrollLock();
        break;
      }
    }
  });
  bodyClassObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  syncWithBodyScrollLock();
})();